export const RolesTypes = {
	All: 'AllPermissions',
	Investors: 'Investors',
	Borrowers: 'Borrowers',
	Reports: 'Reports',
	Loans: 'Loans',
	ControlPanelClient: 'Clients',
	ControlPanelAmlList: 'AmlList',
	ControlPanelAmlReport: 'AmlReport',
	ControlPanelMetaTags: 'ControlPanelMetaTags',
	ControlPanelSystemSettings: 'ControlPanelSystemSettings',
	ControlPanelAdminUsers: 'ControlPanelAdminUsers',
	ControlPanelWelcomeBonus: 'ControlPanelWelcomeBonus',
	ControlPanelGoogleIndexing: 'ControlPanelGoogleIndexing',
	ControlDisbursalChecklist: 'ControlDisbursalChecklist',
	Transactions: 'Transactions',
	TransactionCreation: 'TransactionCreation',
	TransactionActions: 'TransactionActions',
	Subscribers: 'Subscribers',
	BlogArticleCRUD: 'BlogArticleCRUD',
	ComparisonCRUD: 'ComparisonCRUD',
	BlogCategoryCRUD: 'BlogCategoryCRUD',
	FAQItemsCRUD: 'FAQItemsCRUD',
	FAQCategoryCRUD: 'FAQCategoryCRUD',
	TeamMemberCRUD: 'TeamMemberCRUD',
	PromotionalCode: 'PromotionalCode',
	AnnouncementBar: 'AnnouncementBarCRUD',
	PushNotifications: 'PushNotifications',
	SMSNotifications: "SMSNotifications",
	Buckets: 'Buckets',
	StaticPages: 'StaticPages',
	CancelTransaction: 'CancelTransaction',
	CancelDeposit: 'CancelDeposit',
	AutoInvestment: 'AutoInvestment',
	DisburseButton: 'DisburseButton'
};
